module.exports = __webpack_public_path__ + "img/687.8b5c24d6.jpg";